export interface DomTextSearchMatch {
    startOffset: number;
    endOffset: number;
}

export function findTextOccurrences(haystack: string, needle: string, caseSensitive = false): number[] {
    const starts: number[] = [];
    if (!needle) return starts;

    const source = caseSensitive ? haystack : haystack.toLocaleLowerCase('ru-RU');
    const target = caseSensitive ? needle : needle.toLocaleLowerCase('ru-RU');
    let from = 0;
    while (from <= source.length - target.length) {
        const idx = source.indexOf(target, from);
        if (idx === -1) break;
        starts.push(idx);
        from = idx + (target.length || 1);
    }
    return starts;
}

export function searchDomPlainText(
    root: HTMLElement,
    query: string,
    caseSensitive = false,
): DomTextSearchMatch[] {
    const needle = query.trim();
    if (!needle) return [];

    const text = root.textContent ?? '';
    const starts = findTextOccurrences(text, needle, caseSensitive);
    return starts.map((startOffset) => ({
        startOffset,
        endOffset: startOffset + needle.length,
    }));
}
